import { StoreState } from '../store-interfaces';
import AttributeModel, {
  FB_PAGE_PREDEFINED_ATTRIBUTES,
} from '../model/AttributeModel';
import { createSelector } from 'reselect';

export const selectAttributes = (state: StoreState) =>
  state.attribute.entities || [];

const getNonSystemAttributes = (attributes: AttributeModel[]) => {
  return attributes.filter(attr => {
    if (attr.system) return false;
    return !FB_PAGE_PREDEFINED_ATTRIBUTES.includes(attr.name);
  });
};

export const nonSystemAttributesSelector = createSelector(
  [selectAttributes],
  getNonSystemAttributes,
);
